import styled from '@emotion/styled';
import {Headline as HeadlineUi} from 'ui';
import {colors} from 'ui/config';

export const Headline = styled(HeadlineUi)({
  backgroundColor: colors.darkBrown,
  margin: 0,
  paddingTop: 16,
  marginBottom: 24,
});

export const HeadlineContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.darkBrown,
});
